// extracted by mini-css-extract-plugin
export default {"container":"mainPage_container__iM7qt","urlBlock":"mainPage_urlBlock__ZboHC","bodyContainer":"mainPage_bodyContainer__GeSnL"};